import { useEffect, useId, useState } from 'react';

const PICKER_OPEN_EVENT = 'fim3-picker-open';

export function usePickerOpenCoordinator(initialOpen?: boolean) {
  const id = useId();
  const [open, setOpen] = useState(Boolean(initialOpen));

  useEffect(() => {
    if (!open) return;
    const handler = (e: Event) => {
      if ((e as CustomEvent<string>).detail !== id) setOpen(false);
    };
    document.addEventListener(PICKER_OPEN_EVENT, handler);
    return () => document.removeEventListener(PICKER_OPEN_EVENT, handler);
  }, [open, id]);

  return {
    open,
    onOpen: () => {
      document.dispatchEvent(new CustomEvent(PICKER_OPEN_EVENT, { detail: id }));
      setOpen(true);
    },
    onClose: () => setOpen(false),
  };
}
